export default "__VITE_ASSET__DwdpJLzu__"